import { ApiClient } from '@webapp/core/services/ApiClient'
import { CreditCardAccountRepository } from './CreditCardAccountRepository'

export const creditCardAccountRepository = new CreditCardAccountRepository({
  httpClient: ApiClient,
})
